import type { UpgradeRequirements, ResourceBundle } from '@/types/EntityTypes';
import { InfrastructureEntity } from './InfrastructureEntity';

export class PipelineEntity extends InfrastructureEntity {

  constructor(params: {
    id: string;
    name: string;
    description: string;
    cost: number;
    storage?: ResourceBundle;
    consumes?: ResourceBundle;
    produces?: ResourceBundle;
    progressionRequirements?: UpgradeRequirements;
    failureRate?: number;
    maxCount?: number;
  }) {
    super(params);
  }
} 